import { render, staticRenderFns } from "./AddForm.vue?vue&type=template&id=559b9806&scoped=true"
import script from "./AddForm.vue?vue&type=script&lang=js"
export * from "./AddForm.vue?vue&type=script&lang=js"
import style0 from "./AddForm.vue?vue&type=style&index=0&id=559b9806&prod&lang=less"
import style1 from "./AddForm.vue?vue&type=style&index=1&id=559b9806&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559b9806",
  null
  
)

export default component.exports